module.exports = __webpack_public_path__ + "img/DE03891.b1fae611.png";